export const LowIncomeDeviationTableData = [
  {
    adjusted: "1,550",
    one_child: "295.00",
    two_children: "372.00",
    three_children: "388.00",
    four_children: "403.00",
    five_children: "419.00",
    six_children: "434.00"
  },
  {
    adjusted: "1,600.00",
    one_child: "304.00",
    two_children: "389.00",
    three_children: "408.00",
    four_children: "427.00",
    five_children: "444.00",
    six_children: "462.00"
  },
  {
    adjusted: "1,650.00",
    one_child: "314.00",
    two_children: "405.00",
    three_children: "429.00",
    four_children: "450.00",
    five_children: "470.00",
    six_children: "490.00"
  },
  {
    adjusted: "1,700.00",
    one_child: "323.00",
    two_children: "422.00",
    three_children: "450.00",
    four_children: "474.00",
    five_children: "496.00",
    six_children: "518.00"
  },
  {
    adjusted: "1,750.00",
    one_child: "333.00",
    two_children: "439.00",
    three_children: "471.00",
    four_children: "497.00",
    five_children: "522.00",
    six_children: "546.00"
  },
  {
    adjusted: "1,800.00",
    one_child: "342.00",
    two_children: "456.00",
    three_children: "492.00",
    four_children: "521.00",
    five_children: "548.00",
    six_children: "574.00"
  },
  {
    adjusted: "1,850.00",
    one_child: "352.00",
    two_children: "472.00",
    three_children: "513.00",
    four_children: "544.00",
    five_children: "574.00",
    six_children: "601.00"
  },
  {
    adjusted: "1,900.00",
    one_child: "361.00",
    two_children: "489.00",
    three_children: "534.00",
    four_children: "568.00",
    five_children: "599.00",
    six_children: "629.00"
  },
  {
    adjusted: "1,950.00",
    one_child: "371.00",
    two_children: "506.00",
    three_children: "555.00",
    four_children: "591.00",
    five_children: "625.00",
    six_children: "657.00"
  },
  {
    adjusted: "2,000.00",
    one_child: "381.00",
    two_children: "522.00",
    three_children: "576.00",
    four_children: "615.00",
    five_children: "651.00",
    six_children: "685.00"
  },
  {
    adjusted: "2,050.00",
    one_child: "390.00",
    two_children: "539.00",
    three_children: "597.00",
    four_children: "638.00",
    five_children: "677.00",
    six_children: "713.00"
  },
  {
    adjusted: "2,100.00",
    one_child: "400.00",
    two_children: "556.00",
    three_children: "618.00",
    four_children: "662.00",
    five_children: "703.00",
    six_children: "741.00"
  },
  {
    adjusted: "2,150.00",
    one_child: "409.00",
    two_children: "573.00",
    three_children: "639.00",
    four_children: "685.00",
    five_children: "729.00",
    six_children: "769.00"
  },
  {
    adjusted: "2,200.00",
    one_child: "419.00",
    two_children: "589.00",
    three_children: "660.00",
    four_children: "709.00",
    five_children: "754.00",
    six_children: "797.00"
  },
  {
    adjusted: "2,250.00",
    one_child: "428.00",
    two_children: "606.00",
    three_children: "681.00",
    four_children: "732.00",
    five_children: "780.00",
    six_children: "825.00"
  },
  {
    adjusted: "2,300.00",
    one_child: "438.00",
    two_children: "623.00",
    three_children: "702.00",
    four_children: "756.00",
    five_children: "806.00",
    six_children: "853.00"
  },
  {
    adjusted: "2,350.00",
    one_child: "448.00",
    two_children: "639.00",
    three_children: "723.00",
    four_children: "779.00",
    five_children: "832.00",
    six_children: "881.00"
  },
  {
    adjusted: "2,400.00",
    one_child: "457.00",
    two_children: "656.00",
    three_children: "744.00",
    four_children: "803.00",
    five_children: "858.00",
    six_children: "909.00"
  },
  {
    adjusted: "2,450.00",
    one_child: "467.00",
    two_children: "673.00",
    three_children: "765.00",
    four_children: "826.00",
    five_children: "884.00",
    six_children: "936.00"
  },
  {
    adjusted: "2,500.00",
    two_children: "690.00",
    three_children: "786.00",
    four_children: "850.00",
    five_children: "910.00",
    six_children: "964.00"
  },
  {
    adjusted: "2,550.00",
    two_children: "706.00",
    three_children: "807.00",
    four_children: "873.00",
    five_children: "935.00",
    six_children: "992.00"
  },
  {
    adjusted: "2,600.00",
    two_children: "723.00",
    three_children: "828.00",
    four_children: "897.00",
    five_children: "961.00",
    six_children: "1,020.00"
  },
  {
    adjusted: "2,650.00",
    two_children: "740.00",
    three_children: "848.00",
    four_children: "920.00",
    five_children: "987.00",
    six_children: "1,048.00"
  },
  {
    adjusted: "2,700.00",
    two_children: "756.00",
    three_children: "869.00",
    four_children: "944.00",
    five_children: "1,013.00",
    six_children: "1,076.00"
  },
  {
    adjusted: "2,750.00",
    two_children: "773.00",
    three_children: "890.00",
    four_children: "967.00",
    five_children: "1,039.00",
    six_children: "1,104.00"
  },
  {
    adjusted: "2,800.00",
    two_children: "790.00",
    three_children: "911.00",
    four_children: "991.00",
    five_children: "1,065.00",
    six_children: "1,132.00"
  },
  {
    adjusted: "2,850.00",
    two_children: "807.00",
    three_children: "932.00",
    four_children: "1,014.00",
    five_children: "1,090.00",
    six_children: "1,160.00"
  },
  {
    adjusted: "2,900.00",
    two_children: "823.00",
    three_children: "953.00",
    four_children: "1,038.00",
    five_children: "1,116.00",
    six_children: "1,188.00"
  },
  {
    adjusted: "2,950.00",
    two_children: "840.00",
    three_children: "974.00",
    four_children: "1,061.00",
    five_children: "1,142.00",
    six_children: "1,216.00"
  },
  {
    adjusted: "3,000.00",
    three_children: "995.00",
    four_children: "1,085.00",
    five_children: "1,168.00",
    six_children: "1,243.00"
  },
  {
    adjusted: "3,050.00",
    three_children: "1,016.00",
    four_children: "1,108.00",
    five_children: "1,194.00",
    six_children: "1,271.00"
  },
  {
    adjusted: "3,100.00",
    three_children: "1,037.00",
    four_children: "1,132.00",
    five_children: "1,220.00",
    six_children: "1,299.00"
  },
  {
    adjusted: "3,150.00",
    three_children: "1,058.00",
    four_children: "1,155.00",
    five_children: "1,245.00",
    six_children: "1,327.00"
  },
  {
    adjusted: "3,200.00",
    three_children: "1,079.00",
    four_children: "1,179.00",
    five_children: "1,271.00",
    six_children: "1,355.00"
  },
  {
    adjusted: "3,250.00",
    three_children: "1,100.00",
    four_children: "1,202.00",
    five_children: "1,297.00",
    six_children: "1,383.00"
  },
  {
    adjusted: "3,300.00",
    three_children: "1,121.00",
    four_children: "1,226.00",
    five_children: "1,323.00",
    six_children: "1,411.00"
  },
  {
    adjusted: "3,350.00",
    three_children: "1,142.00",
    four_children: "1,249.00",
    five_children: "1,349.00",
    six_children: "1,439.00"
  },
  {
    adjusted: "3,400.00",
    four_children: "1,273.00",
    five_children: "1,375.00",
    six_children: "1,467.00"
  },
  {
    adjusted: "3,450.00",
    four_children: "1,296.00",
    five_children: "1,401.00",
    six_children: "1,495.00"
  },
  {
    adjusted: "3,500.00",
    four_children: "1,320.00",
    five_children: "1,426.00",
    six_children: "1,523.00"
  },
  {
    adjusted: "3,550.00",
    four_children: "1,343.00",
    five_children: "1,452.00",
    six_children: "1,550.00"
  },
  {
    adjusted: "3,600.00",
    five_children: "1,478.00",
    six_children: "1,578.00"
  },
  {
    adjusted: "3,650.00",
    five_children: "1,504.00",
    six_children: "1,606.00"
  },
  {
    adjusted: "3,700.00",
    five_children: "1,530.00",
    six_children: "1,634.00"
  },
  {
    adjusted: "3,750.00",
    five_children: "1,556.00",
    six_children: "1,662.00"
  },
  {
    adjusted: "3,800.00",
    six_children: "1,690.00"
  },
  {
    adjusted: "3,850.00",
    six_children: "1,718.00"
  },
  {
    adjusted: "3,900.00",
    six_children: "1,746.00"
  },
  {
    adjusted: "3,950.00",
    six_children: "1,774.00"
  }
];